module.exports = __webpack_public_path__ + "static/media/overpass-heavy-italic.e171c10c.eot";